import React from "react";
import numeral from "numeral";

interface IBudgetProps {
  budget: number;
  currency: string;
}

export default function GovernmentBudget({ budget, currency }: IBudgetProps) {
  return <span>{getFormattedBudget(budget, currency)}</span>;
}

export function getFormattedBudget(budget: number, currency: string) {
  const formatted = budget > 1000 ? numeral(budget).format("0.0a") : budget;

  if (currency === "USD") {
    return `$${formatted}`;
  }

  if (currency === "GBP") {
    return `£${formatted}`;
  }

  if (currency === "EUR") {
    return `€${formatted}`;
  }

  if (currency === "CAD") {
    return `CA$${formatted}`;
  }

  if (currency === "AUD") {
    return `AU$${formatted}`;
  }

  if (currency === "NZD") {
    return `NZ$${formatted}`;
  }

  if (currency === "ZAR") {
    return `R${formatted}`;
  }

  if (currency === "BRL") {
    return `R$${formatted}`;
  }

  if (currency === "SEK") {
    return `SEK${formatted}`;
  }

  if (currency === "DKK") {
    return `DKK${formatted}`;
  }

  if (currency === "MXN") {
    return `MX$${formatted}`;
  }

  if (currency === "ARS") {
    return `ARS${formatted}`;
  }

  return `${formatted}`;
}
